<template>
  <main class="index" :class="[`index--${project_name}`,]" />
</template>


<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'index',

  data () {
    return {}
  },
  computed: {
    ...mapState([
      'project_name',
    ]),
    ...mapGetters('tests', [
      'project_pages',
    ]),
  },
  created () {
    this.$log.info('=========================')
    this.$log.info('CREATED: Index component')

    this.default_store_preparation()
      .then(() => {
        this.$log.debug('Store preparation successfully completed in Index :)')
        this.choose_next_route()
      })
      .catch(err => {
        this.$log.debug('Store preparation rejected in Index :(')
        console.warn('rejected with:', err)
        this.choose_next_route()
      })
  },
  mounted () {
    this.$log.info('=========================')
    this.$log.info('MOUNTED: Index component')
    this.hide_loader()
  },

  methods: {
    ...mapActions([
      'default_store_preparation',
      'hide_loader',
    ]),
    choose_next_route () {
      console.log('choose_next_route() called in Index')
      if (this.project_pages.length) {
        console.log('got pages, loading Page...')
        this.$router.push({ name: 'page' })
      } else {
        console.log('no pages, loading Test...')
        this.$router.push({ name: 'test' })
      }
    }
  },
}
</script>


<style lang="less" scoped>
  @import '../variables';
</style>
